import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { FormTemplateService } from './../services/form-template.service';
import { ILinkbox } from './../models/linkbox.model';
import { TextDictionaryService } from './../services/text-dictionary.service';
import { ITextEntry } from './../models/text-dictionary.model';
import { ITextDictionary } from './../models/text-dictionary.model';
import textList from '../../assets/data/text-dictionary.json';
import { ZenplansTestDataProviderService } from './../services/zenplans-test-data-provider.service';
import { DynamicHelpers } from './../helpers/dynamic-helpers';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.scss']
})

export class DynamicFormComponent implements OnInit, OnDestroy {
  formResult: string = "no results yet";
  myFormGroup: FormGroup;
  myFormTemplate: ILinkbox; // = this.form_template;
  templateName;
  formType = false;
  linkType = false;
  sectionTitle = "";
  fts;
  showHelp = false;
  textDictionary: ITextDictionary;
  myTextDictionary = {};
  myTextList = textList;

  constructor(private activatedRoute: ActivatedRoute,
    private router: Router, private ftService: FormTemplateService,
    private dictService: TextDictionaryService,
    private zenplansTestDataProviderService: ZenplansTestDataProviderService,
    private http: HttpClient) {
    this.activatedRoute.paramMap.subscribe(params => {
      this.templateName = params.get('templateName');
      this.getCards();
    });
  }

  ngOnInit() {
    //this.getDict();
  };
  // async getDict(){
  //   //this.textDictionary = await this.tdService.getDictionary();
  //   this.myTextDictionary = await this.tdService.getDictionary();
  // }
  async getCards() {
    this.myFormTemplate = await this.ftService.getFormTemplateAsync(this.templateName);
    let group = {}
    let counter = 0;
    switch (this.templateName) {
      case "my-plan":
        this.myFormTemplate.cards.forEach(async card => {
          card.cardId = "object_" + counter++;
          let sectionStatus = await this.zenplansTestDataProviderService.getPlanCategoryStatus(card.title.toLowerCase());
          let count = sectionStatus["upToDates"] + sectionStatus["forReviews"];
          card.itemCount = count;
        });
        break;
      case "home":
        this.myFormTemplate.cards.forEach(async card => {
          if (card.title == "My Zenplan") {
            card.cardId = "object_" + counter++;
            let count = await this.zenplansTestDataProviderService.getAllZenPlanItemCount();
            card.itemCount = count;
          }
          if (card.title == "My Delegates") {
            card.cardId = "object_" + counter++;
            let count = await this.zenplansTestDataProviderService.getDelegatesCount();
            card.itemCount = count;
          }
        });
        break;
      default:
        this.myFormTemplate.cards.forEach(async card => {
          card.cardId = "object_" + counter++;
          card.itemCount = await this.getItemCount(card.url, card.title);
        });
        break;
    }

    //var count = await this.getItemCount(this.myFormTemplate.cards[0].url,this.templateName);
    this.sectionTitle = await this.getText(this.myFormTemplate.sectionTitle);
  }

  onSubmit() {
    console.log(this.myFormGroup.value);
    this.formResult = this.myFormGroup.value;
  }

  goto(url: string) {
    this.router.navigate(['/' + url]);
  }

  toggleCard(formElement) {
    let kk = formElement;
  }

  toggleHelp() {
    if (this.myFormTemplate.help) {
      const helpContainer = document.getElementById('helpContainer');
      helpContainer.classList.toggle('opened');
      // this.showHelp=!(this.showHelp);
    }
  }

  showButtonCard(objectId) {
    var x = document.getElementById(objectId + "_Second");
    if (x.style.display === "none") {
      x.style.display = "flex";
    } else {
      x.style.display = "none";
    }
    var x = document.getElementById(objectId + "_First");
    if (x.style.display === "none") {
      x.style.display = "flex";
    } else {
      x.style.display = "none";
    }
  }

  async getText(key: string) {
    let txt = await this.dictService.getText(key); //this.myTextList.find(kk=>kk.key==key).value;
    return txt;
  }

  public async getItemCount(fatherUrl, fatherTitle) {

    var counter: number;
    var zendata = new ZenplansTestDataProviderService();
    var template;
    try {
      template = await this.http.get<ILinkbox>("assets/formtemplates/" + fatherUrl + ".json").toPromise();
    }
    catch{
      template = null;
    }

    if (template && template.cards) {
      template.cards.map(async card => {
        counter += await this.getItemCount(card.url, card.title);
      })
    }
    else {
      var count = 0;
      try {
        count = await zendata.getSectionItemCount(fatherTitle);
      }
      catch{
        count = 0;
      }
      return count;
    }
    return counter;
  }

  ngOnDestroy() {

  }

}

// form_template =
  //   {
  //     "formtitle": "",
  //     "formtype": "linkcards",
  //     "cards": [
  //       {
  //         "type": "linkBoxToggle",
  //         "title": "My Zenplan",
  //         "subtitle": "",
  //         "icon": "fa fa-2x fa-caret-right",
  //         "openCardTitle": "Here is where you can build, simple to create picture",
  //         "url": "demo"
  //       },
  //       {
  //         "type": "linkBoxToggle",
  //         "title": "My Dashboard",
  //         "subtitle": "",
  //         "icon": "fa fa-2x fa-caret-right",
  //         "openCardTitle": "Get a snap-shot view of your plan's status, telling you what to add and what to update",
  //         "url": "demo"
  //       },
  //       {
  //         "type": "linkBoxToggle",
  //         "title": "My Delegates",
  //         "subtitle": "",
  //         "icon": "fa fa-2x fa-caret-right",
  //         "openCardTitle": "Share your zen plan with those closests to you so they can view it today, or in the future",
  //         "url": "demo"
  //       },
  //       {
  //         "type": "linkBoxToggle",
  //         "title": "My Shared Plans",
  //         "subtitle": "",
  //         "openCardTitle": "Here you can view all the plans that others have chosen to share with you",
  //         "icon": "fa fa-2x fa-caret-right",
  //         "url": "demo"
  //       }
  //     ]
  //   };
  // ,
  //   {
  //     "type": "textBox",
  //     "controlName": "Name",
  //     "label": "My Name"
  //   },
  //   {
  //     "type": "number",
  //     "controlName": "Age",
  //     "label": "My Age"
  //   },
  //   {
  //     "type": "select",
  //     "controlName": "favoritebook",
  //     "options": ["Choose Book", "Jane Eyre", "Pride and Prejudice", "Wuthering Heights"],
  //     "label": "My Favorite Book"
  //   }
  // ]
